<script setup lang="ts">
  import type { ServiceMenuItem } from '@/models/service';
  import type { PropType } from 'vue';
  import { useMenu } from '@/composables/useMenu';

  const props = defineProps({
    items: {
      type: Array as PropType<ServiceMenuItem[]>,
      required: true
    }
  });

  const { swiperRef, shouldHideButtons, prev, next } = useMenu(props.items);

  const localePath = useLocalePath();
</script>

<template>
  <div class="use-case-menu">
    <div
      v-if="!shouldHideButtons"
      :class="['use-case-menu__btn', 'use-case-menu__btn--prev']"
      tabindex="0"
      @click.prevent.stop="prev" />
    <swiper-container
      v-if="items.length"
      ref="swiperRef"
      class="use-case-menu__container"
      slides-per-view="auto"
      :update-on-window-resize="true"
      :space-between="0"
      :init="false">
      <swiper-slide
        v-for="(item, index) in items"
        :key="index"
        class="use-case-menu__item">
        <NuxtLink :to="localePath({ name: 'use-cases-slug', params: { slug: item.slug } })">
          <span>{{ item.title }}</span>
        </NuxtLink>
        <span v-if="index < items.length - 1" />
      </swiper-slide>
    </swiper-container>
    <div
      v-if="!shouldHideButtons"
      :class="['use-case-menu__btn', 'use-case-menu__btn--next']"
      tabindex="0"
      @click.prevent.stop="next" />
  </div>
</template>
